// Logique pure du jeu, extraite de Game pour être claire et testable (aucun DOM).

/** Courbe de vitesse : quadratique passant par (0→start), (0.5→mid), (1→end). */
export function speedFactor(p: number, start: number, mid: number, end: number): number {
  const b = 2 * (end + start - 2 * mid);
  const a = end - start - b;
  return start + a * p + b * p * p;
}

/** Justesse → points : 3 (PARFAIT) si très centré, 2 (BIEN), sinon 1 (OK). */
export function precisionPoints(distance: number, tolerance: number): 1 | 2 | 3 {
  if (distance <= tolerance / 3) return 3;
  if (distance <= (2 * tolerance) / 3) return 2;
  return 1;
}

/** Transform géométrique d'un point du nez vers l'écran : échelle puis rotation
 *  autour du pivot (px,py), puis translation dx. */
export function transformPoint(
  lx: number,
  ly: number,
  t: { dx: number; a: number; sc: number; px: number; py: number },
): { x: number; y: number } {
  const X = (lx - t.px) * t.sc;
  const Y = (ly - t.py) * t.sc;
  return {
    x: t.px + X * Math.cos(t.a) - Y * Math.sin(t.a) + t.dx,
    y: t.py + X * Math.sin(t.a) + Y * Math.cos(t.a),
  };
}
